import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, signal } from '@angular/core';
import { KsefGetCollectiveIdentifiersByKsefNumberQuery } from '@skylab-angular-shared/business';
import { QueryBus } from '@skylab-angular-shared/core';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { ButtonComponent, DialogContentComponentBase, DialogContentComponentIns, DialogHeaderComponentIns, IconComponent, SpinnerComponent } from '@skylab-angular-shared/ui';
import { CopyToClipboardDirective } from '../../common/copy-to-clipboard/copy-to-clipboard.directive';

@Component({
    selector: 'skl-ksef-collective-identifiers-list-dialog',
    template: `
        <skl-dialog-content-ins>
            <skl-dialog-header-ins
                [title]="'scenes.shared.ksef-collective-identifier.dialog.title' | translate"
                (onClose)="onCancel()">
            </skl-dialog-header-ins>

            <ins-content>
                @if (collectiveIdentifiers()) {
                    <div class="items">
                        @for (item of collectiveIdentifiers(); track item) {
                            <div class="item">
                                {{ item }}
                                <skl-button
                                    typeName="transparent"
                                    [sklCopyToClipboard]="item">
                                    <skl-icon
                                        class="icon--clickable"
                                        name="list-copy">
                                    </skl-icon>
                                </skl-button>
                            </div>
                        }
                    </div>

                } @else {
                    <div class="spinner-wrapper">
                        <skl-spinner
                            [invert]="false"
                            [size]="175">
                        </skl-spinner>
                    </div>
                }
            </ins-content>

            <ins-footer class="dialog__buttons">
                <skl-button
                    (click)="onCancel()">
                    {{'scenes.shared.ksef-collective-identifier.dialog.buttons.close' | translate}}
                </skl-button>
            </ins-footer>
        </skl-dialog-content-ins>
    `,
    styles: [`
        .items {
            display: grid;
            gap: 8px;
            margin: 8px 10px;
        }

        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            min-width: 0;
            padding: 10px 12px;
            border: 1px solid var(--line-1-color);
            overflow-wrap: anywhere;
            font-weight: 400;
            font-size: 15px;
            border-radius: 6px;
            background: var(--surface-3-color);
        }

        .item skl-button {
            flex: 0 0 auto;
        }

        .spinner-wrapper {
            height: 250px;
        }
    `],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, ButtonComponent, TranslatePipe, ButtonComponent, CopyToClipboardDirective, IconComponent, SpinnerComponent]
})
export class KsefCollectiveIdentifiersListDialogComponent extends DialogContentComponentBase<any, { ksefDocumentId: string }> {
    collectiveIdentifiers = signal<string[] | null>(null);
    #queryBus = inject(QueryBus);

    protected override async prepareDataAsync(): Promise<void> {
        await super.prepareDataAsync();
        const result = await this.#queryBus.queryAsync(new KsefGetCollectiveIdentifiersByKsefNumberQuery({ksefNumber: this.data.ksefDocumentId}));
        this.collectiveIdentifiers.set(result?.collectiveIdentifiers ?? []);
    }
}
